import { AppResources } from "@/constants.ts";

export const EVENT_IDS: { [key: string]: string } = {
  taxTuesday: "85606669221",
  wildWednesday: "83492714777",
};

export const TAX_TUESDAY_IMG_URL = AppResources.demoTaxTuesday;
export const WILD_WEDNESDAY_IMG_URL = AppResources.demoWildWednesday;

export const demoData = [
  {
    imageSrc: AppResources.demoBook,
    title: "Book a 1-on-1 Onboarding Call",
    description:
      "Still confused about the product? Book a call with us and see how SmartWiz can help your business.",
    buttonText: "Book a call",
    buttonHandler: "openCalendlyURL",
  },
  {
    imageSrc: TAX_TUESDAY_IMG_URL,
    title: "Join the SmartWiz Tax Tuesdays!",
    description:
      "Join us to learn how to navigate the product and explore walk-throughs for common tax-related use cases, ensuring you get the most out of SmartWiz.",
    buttonText: "Register now",
    buttonHandler: "openTaxTuesdayModal",
    eventType: "taxTuesday",
  },
  {
    imageSrc: WILD_WEDNESDAY_IMG_URL,
    title: "Join the SmartWiz Wild Wednesdays!",
    description:
      "Join us to gain valuable insights, enhance your skills, and drive your success to new heights with special guests and experts.",
    buttonText: "Register now",
    buttonHandler: "openWildWednesdayModal",
    eventType: "wildWednesday",
  },
];
